export default __webpack_public_path__ + "219ddee3cb879df7b61e6e884a72f5b3.png";